import { useQuery } from 'react-query'
import axios from 'axios'

import { baseUrl } from 'configs/api'
import { handleCommonErrors } from 'utils/api'

import type { IInfoTerkiniDetail } from 'types/info-terkini'

export interface ResponseSuccessInfoTerkiniDetail {
  data: IInfoTerkiniDetail
  meta: {}
}

export function useAPIInfoTerkiniDetail(id: string) {
  const apiPath = `${baseUrl}/aum/announcement/v2/announcements/${id}`

  return useQuery<any, any, ResponseSuccessInfoTerkiniDetail>(
    ['info-terkini-detail', id],
    async () => {
      try {
        const response = await axios.get<any>(apiPath)
        const data = await response.data
        return data
      } catch (error) {
        handleCommonErrors(error?.response?.status, apiPath, error)
      }
    },
    {
      useErrorBoundary: true,
    }
  )
}
